import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const SubmitConfirmModal = ({ totalQuestions, answeredCount, onConfirm, onCancel }) => {
  const unanswered = totalQuestions - answeredCount;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className="w-full max-w-md rounded-2xl p-6 md:p-8 shadow-2xl"
        style={{ backgroundColor: "var(--color-card)" }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div
            className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: unanswered > 0 ? "rgba(217,119,6,0.1)" : "rgba(5,150,105,0.1)" }}
          >
            <Icon
              name={unanswered > 0 ? "AlertTriangle" : "CheckCircle"}
              size={22}
              color={unanswered > 0 ? "var(--color-warning)" : "var(--color-success)"}
              strokeWidth={2}
            />
          </div>
          <h2
            id="modal-title"
            className="font-semibold text-lg md:text-xl"
            style={{ color: "var(--color-text-primary)" }}
          >
            Soumettre le QCM ?
          </h2>
        </div>

        <div
          className="rounded-lg p-4 mb-6 space-y-2"
          style={{ backgroundColor: "var(--color-muted)" }}
        >
          <div className="flex justify-between text-sm">
            <span style={{ color: "var(--color-muted-foreground)" }}>Questions répondues</span>
            <span className="font-mono font-semibold" style={{ color: "var(--color-success)" }}>
              {answeredCount} / {totalQuestions}
            </span>
          </div>
          {unanswered > 0 && (
            <div className="flex justify-between text-sm">
              <span style={{ color: "var(--color-muted-foreground)" }}>Questions sans réponse</span>
              <span className="font-mono font-semibold" style={{ color: "var(--color-warning)" }}>
                {unanswered}
              </span>
            </div>
          )}
        </div>

        {unanswered > 0 && (
          <p className="text-sm mb-6" style={{ color: "var(--color-warning)" }}>
            <Icon name="Info" size={14} color="var(--color-warning)" className="inline mr-1" />
            Attention : {unanswered} question{unanswered > 1 ? "s" : ""} sans réponse. Les questions non répondues seront comptées comme incorrectes.
          </p>
        )}

        <p className="text-sm mb-6" style={{ color: "var(--color-muted-foreground)" }}>
          Cette action est définitive. Vous ne pourrez plus modifier vos réponses après la soumission.
        </p>

        <div className="flex gap-3">
          <Button variant="outline" fullWidth onClick={onCancel}>
            Annuler
          </Button>
          <Button variant="success" fullWidth onClick={onConfirm} iconName="Send" iconPosition="right">
            Confirmer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubmitConfirmModal;